import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import NuevoProveedor from './NuevoProveedor';
import { getProveedores } from '../../../actions/proveedores';
import TablaProveedores from './tablaProveedores/TablaProveedores';
import { useValue } from '../../../context/ContextProvider';

const GestionProveedores = () => {
    /* To Do: Cambiar este modelo de permisos por uno que controle el servidor */
    const permisos = ['superusuario', 'administrador', 'cajero'];

    const navigate = useNavigate();
    const { state: { contextLoading, currentUser, proveedores }, dispatch } = useValue();
    const [visibilidad, setVisibilidad] = useState(false);
    //const [proveedores, setProveedores] = useState([]);
    const [openNuevoProveedor, setOpenNuevoProveedor] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [oldRow, setOldRow] = useState(null);
    const [newRow, setNewRow] = useState(null);
    const [editRowId, setEditRowId] = useState(null);

    useEffect(() => {
        //Renderiza la pagina al principio y cuando contextLoading cambia a falso. Código para hecho para refresh, cambio de páginas y autorizaciones
        //console.log('useEffect GestionProveedores');
        if (!contextLoading) {
            if (!permisos.includes(currentUser?.tipoUsuario)) {
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Página no autorizada! Redirecionando a Inicio.' } });
                navigate('/');
            } else {
                if (proveedores.length == 0) {
                    //console.log('Solicitando Proveedores al servidor.');
                    //getProveedores('todo', currentUser, dispatch, setProveedores);
                    getProveedores('todo', currentUser, dispatch);
                }
                setVisibilidad(true);
            }
        }
    }, [contextLoading, currentUser]);


    const handleNuevoProveedor = () => {
        setEditRowId(0);    //Significa ninguna fila editandose
        setOpenNuevoProveedor(true);
    }

    return (
        <>
            {visibilidad ?
                <Stack
                    direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
                    spacing={0}
                    justifyContent={{ lg: 'center' }}
                    flexGrow={1} pt={2} pb={2}
                >
                    <Box bgcolor='white' borderRight={1} borderColor='lightgray' flex={8} marginRight={0} padding={2} style={{ width: '100%', borderRadius: 0 }} >
                         <Box m='auto' style={{ height: 600, maxWidth: '880px', backgroundColor: 'white' }}>
                            <TablaProveedores
                                currentUser={currentUser}
                                dispatch={dispatch}
                                proveedores={proveedores}
                                //setProveedores={setProveedores}
                                editRowId={editRowId}
                                setEditRowId={setEditRowId}
                                setOpenNuevoProveedor={setOpenNuevoProveedor}
                                setOldRow={setOldRow}
                            />
                        </Box >

                    </Box>
                    <Box bgcolor='white' flex={4} padding={2} style={{ borderRadius: 0, width: '100%' }}>
                        <Stack direction={'column'}>
                            <Typography variant="h6" component="h5" p={2} align='center'>
                                Gestión de datos
                            </Typography>

                            <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                            >
                                <Box width={'80%'} maxWidth={'400px'}>
                                    <Button variant='outlined' onClick={handleNuevoProveedor} fullWidth={true} >Nuevo Proveedor</Button>
                                </Box>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
                :
                <div>Página no autorizada.</div>

            }
            <NuevoProveedor
                openNuevoProveedor={openNuevoProveedor}
                setOpenNuevoProveedor={setOpenNuevoProveedor}
                isUpdate={isUpdate}
                setIsUpdate={setIsUpdate}
                oldRow={oldRow}
                proveedores={proveedores}
                //setProveedores={setProveedores}
                editRowId={editRowId}
                setEditRowId={setEditRowId}
                //onCellEditStop={(params) => handleEdit(params)}
            />
        </>
    )
}

export default GestionProveedores